



















































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import LendingAccount from "@/models/Accounts/LendingAccounts/LendingAccount";
import LedgerState from '@/components/Accounts/LendingAccounts/Ledgers/LedgerState.vue';
import SimulatedField from '@/components/Accounts/Shared/SimulatedField.vue';
import Schedule from '@/models/Accounts/LendingAccounts/Schedules/Schedule';

@Component({ name: 'LedgerOverview', components: { LedgerState, SimulatedField } })
export default class extends SaascadaVue {

    @Prop({required: true})
    account: LendingAccount;

    @Prop({required: true})
    schedule: Schedule;

    get simulationModeEnabled() {
        return LendingAccountModule.simulationModeEnabled;
    }

    get simulation() {
        return LendingAccountModule.simulation;
    }

}
